export interface PostgresIntervalType {
  years?: number;
  months?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

export interface OnlineOrderingSettingsDto {
  id?: number;
  restaurantId?: number | string;
  enableOnlineOrdering?: boolean;
  enableCustomerReviews?: boolean;
  autoApproveCustomerReviews?: boolean;
  hideOutOfStockItems: boolean;
  hideTimeBasedMenuItems: boolean;
  specialRequestsOnItems: boolean;
  specialRequestsOnOrder: boolean;
  applyDeliveryFee: boolean;
  enableDeliveryTracking: boolean;
  enableInStorePickup: boolean;
  // referenceed in restaurants table
  autoFire?: boolean;
  autoFireTimer?: PostgresIntervalType;
  onlineOrderTimer?: PostgresIntervalType;
}

export enum DefaultQROrderingType {
  DINE_IN = 'dine-in',
  TAKEOUT = 'takeout',
  BOTH = 'both',
}
